import { getPath } from '@speeki/client-admin';

import {
    StatisticsCard,
    StatisticsCardProps,
} from '@components/molecules/StatisticsCards/StatisticsCard';

interface CollectCardProps
    extends Pick<StatisticsCardProps, 'statistics' | 'hidden' | 'loading'> {}

export const CollectCard = ({
    hidden,
    loading,
    statistics,
}: CollectCardProps) => {
    return (
        <StatisticsCard
            actionLink={{
                href: getPath({
                    path: '/engagement/collect',
                }),
                text: 'Go to Collect',
            }}
            description="Summary of collect form statuses."
            hidden={hidden}
            loading={loading}
            statistics={statistics}
            title="Collect"
        />
    );
};
